import React from 'react';
import DataTable from "@inspinia-react/data-table";
import { api, get, getBranchOwner } from '@config'

import Ipi from './index';
import { checkIfBranchExists } from '../../../../../utils';


export default class IPiList extends React.Component {
    constructor(props) {
        super(props)
        checkIfBranchExists()
        this.state = { list: [] }
        this.branch = getBranchOwner().id
    }

    UNSAFE_componentWillMount() {
        setTimeout(() => this.getIPIList(), 300);
    }

    getIPIList() {
        const payload = resp => {
            this.setState({ ...this, list: resp })
        }
        get(`${api.ipi}?branch_owner=${this.branch}`, payload)
    }

    render() {
        return <div className="div">
            <h1 className='text-center' >IPI</h1>
            <div className="text-center">
                <Ipi payload={() => this.getIPIList()} hideSelect />
            </div> 
        </div>
    }
} 


// WEBPACK FOOTER //
// ./src/components/pages/fiscal/taxes/ipi/list.jsx